<template>
  <div class="head-right">
                 <div v-if="!btnBack" class="d-flex aligtitle" >
                   <button type="button" v-on:click="back" v-if="!buttonbackCustom" class="btn btn-third btn-sm ml-3" style="scale:1.2"><i class="fas fa-arrow-circle-left "></i></button>
                   <button type="button" v-on:click="$router.back()" v-else-if="buttonbackCustom === true" class="btn btn-third btn-sm ml-3" style="scale:1.2"><i class="fas fa-arrow-circle-left "></i></button>
                   <button type="button" v-on:click="$router.back()" v-else-if="buttonbackCustom === null" class="btn btn-third btn-sm ml-3" style="scale:1.2"><i class="fas fa-arrow-circle-left ">ssss</i></button>
                   <button type="button" v-on:click="$emit('back')" v-else class="btn btn-third btn-sm ml-3" style="scale:1.2"><i class="fas fa-arrow-circle-left "></i></button>
                   <span class="head-title-rg ml-2">{{titleHead}}</span>
                 </div>
                <div v-if="btnBack" class="d-flex aligtitle" >
                   <button type="button" v-on:click="$emit('voltarPersonalizado', obj)" v-if="!buttonbackCustom" class="btn btn-third btn-sm ml-3" style="scale:1.2"><i class="fas fa-arrow-circle-left "></i></button>
                   <span class="head-title-rg ml-2">{{titleHead}}</span>
                 </div>
                 <div v-if="btnEspelhoVenda" class="btnEV">
                   <button v-b-tooltip.hover title="Adicionar Imagem" v-on:click="$emit('openIS')" class="buttonImage mx-1"><i class="fas fa-map-marked"></i></button>
                   <button v-on:click="$emit('openF')" class="btn-new-gru btn-gru mr-2"><i class="fas fa-file-excel mr-2"></i>IMPORTAR TABELA</button>
                 </div>
                 <div v-if="btnEdit" class="button-group">
                   <div v-if="btnResetPassword">
                     <button v-on:click="$emit('openModal', 'reset-password-modal')" class="btn-head mx-1"><i class="fas fa-lock pr-2"></i>Restaurar Senha</button>
                   </div>
                   <button v-if="btnResetPassword" v-on:click="$emit('openModal','inactivate-user-modal')" class="btn-cancel mx-1" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonInactive"><i class="fas fa-times" style="color:red"></i></button>
                   <button v-if="!btnResetPassword" v-on:click="$emit('openModal','inactivate-user-modal')" class="btn-cancel mx-1" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonActive"><i class="fa fa-check text-success icone-grid"></i></button>
                   <button v-on:click="$emit('openModal','delete-user-modal')" class="btn-cancel mx-1"><i class="fas fa-trash" style="color:black"></i></button>
                 </div>
                 <div v-if="btnApproveUser" class="button-group">
                   <button v-on:click="$emit('openModal', 'approve-user-modal')" class="btn-head mx-1" ><i class="fas fa-thumbs-up pr-2"></i>Aprovar Usuário</button>
                   <button v-on:click="$emit('openModal','inactivate-user-modal')" class="btn-cancel mx-1"><i class="fas fa-times" style="color:red"></i></button>
                   <button v-on:click="$emit('openModal','delete-user-modal')" class="btn-cancel mx-1"><i class="fas fa-trash" style="color:black"></i></button>
                 </div>
                 <div v-if="btnTabela" class="mt-2 mr-2">
                   <button @click="$emit('teste')" class="btnTabela"><i class="fas fa-file-excel mr-1"></i> IMPORTAR TABELA</button>
                 </div>

                 <div v-if="btnImportPdf" class="btnImportExPdf">
                   <div>
                     <button @click="$emit('openUploadPopup')" class="btn-new-gru mr-2"><i class="fas fa-file-pdf mr-2"></i>IMPORTAR TABELA PDF</button>
                   </div>
                </div>

                <div class="d-flex btnImportExPdf" v-if="btnNewEnterprise">
                  <button v-on:click="$emit('AddNewCreden')" class="btn-new-gru mr-2"><i class="fas fa-plus mr-2"></i>ADICIONAR NOVO</button>
                </div>

                 <div class="btnSolicitacao" v-if="btnSolicitacoes">
                  <div class="btnRequest">
                   <b-button v-b-modal.RequestModal class="btnApproveRequest  ml-1">
                      <i class="fas fa-thumbs-up"></i>
                     Aprovar Solicitação
                   </b-button>
                 </div>
                 <div class="btnRequest d-flex">
                   <b-button @click="$emit('cancelarSolicitacao')" class="btnApproveRequestCancelar mr-1">
                     <i class="fas fa-thumbs-down"></i>
                     Cancelar Solicitação
                   </b-button>
                 </div>
                 </div>

                 <div v-if="selectHead" class="">
                   <slot name="selectTable"></slot>
                 </div>
                 <div v-if="btnCanceSave" class="button-group">
                   <button v-if="nextstatus" class="btn-head mx-1" @click="$emit('nextstatus')"><i class="fas fa-thumbs-up mr-2"></i>Aprovar</button>
                   <button v-on:click="$emit('cancel')" class="btn-head-can mx-1"><i v-if="iconCancel" :class="iconCancel" class="mr-2"></i>CANCELAR</button>
                   <button v-on:click="$emit('save')" class="btn-head mx-1"><i :class="iconSave ? iconSave : 'fas fa-save'" class="mr-2"></i>SALVAR</button>
                 </div>
                 <div class="btnRequest" v-if="buttontemplate">
                   <slot name="button-edit"></slot>
                 </div>
                 <div class="btnRequest" v-if="btnApproveRequest">
                   <b-button v-b-modal.RequestModal class="btnApproveRequest  ml-1">
                      <i class="fas fa-thumbs-up"></i>
                     Aprovar Solicitação
                   </b-button>
                 </div>
                 <div class="btnRequest d-flex" v-if="btnApproveRequest">
                   <b-button @click="$emit('cancelarSolicitacao')" class="btnApproveRequestCancelar mr-1">
                     <i class="fas fa-thumbs-down"></i>
                     Cancelar Solicitação
                   </b-button>
                 </div>
                 <div class="btnRequest" v-if="btnPendencyApproveRequest">
                   <b-button v-b-modal.RequestModal class="btnApproveRequest">
                     <i class="fas fa-thumbs-up"></i>
                     Resolver Pendência
                   </b-button>
                 </div>
                 <div class = "d-flex" v-if="buttonsAccredited">
                   <div v-if="btnNewCorretor" class="button-group">
                     <button v-on:click="$emit('salve')" class="buttonAddCorretor"><i class="fas fa-plus"></i></button>
                   </div>
                   <div v-if="btnNew" class="button-group">
                     <button v-on:click="$emit('openbrokerlink')" class="buttonAddEmpreendimento mx-1"><i class="fas fa-user mr-1"></i> Corretores </button>
                   </div>
                   <div v-if="btnNewEmpreendimento" class="button-group" >
                     <button v-on:click="$emit('salve')" class="buttonAddEmpreendimento mx-1"><i class="far fa-building mr-1"></i> Empreendimentos </button>
                   </div>
                   <div v-if="btnNewAdd" class="button-group" >
                     <button v-on:click="$emit('add')" class="buttonAddEmpreendimento mx-1"><i class="fas fa-plus-circle"></i> ADICIONAR </button>
                   </div>
                   <div v-if="btnNewPdf" class="button-group" >
                     <button v-on:click="$emit('pdf')" class="butonPdf mx-1"><i class="fas fa-file-pdf"></i> BAIXAR PDF </button>
                   </div>
                  <div v-if="btnNewRecibo" class="button-group" >
                     <button v-on:click="$emit('recibo')" class="buttonAddEmpreendimento mx-1"><i class="fas fa-file-pdf"></i>  BAIXAR RECIBO </button>
                   </div>
                  <div v-if="btnTime" class="button-group" >
                     <button v-b-tooltip.hover  :title="$lang.Common.Tooltip.ButtonTime" v-on:click="$emit('time')" class="buttonTime mx-1"><i class="fa fa-exclamation-triangle"></i></button>
                   </div>
                    <div v-if="btnAnexDown" class="button-group" >
                     <!-- <button v-on:click="$emit('newAnex')" class="buttonAddEmpreendimento mx-1"><i class="fas fa-plus-circle"></i> NOVO ANEXO</button> -->
                     <button v-on:click="$emit('dowload')" class="buttondown mx-1"><i class="fas fa-download"></i>  </button>
                   </div>
                    <div v-if="btnSing" class="button-group" >
                     <button v-on:click="$emit('setSing')" class="buttonAddEmpreendimento mx-1"><i class="fas fa-signature mr-1"></i>Assinatura</button>
                   </div>
                 </div>
   </div>
</template>

<script>
export default {
  props: {
    buttonsAccredited: {
      type: Boolean,
      default: false
    },
    btnEspelhoVenda: {
      type: Boolean,
      default: false
    },
    btnImages: {
      type: Boolean,
      default: false
    },
    btnTabela: {
      type: Boolean,
      default: false
    },
    btnEdit: {
      type: Boolean,
      default: false
    },
    nextstatus: {
      type: Boolean,
      default: false
    },
    btnResetPassword: {
      type: Boolean,
      default: true
    },
    btnNewPdf: {
      type: Boolean,
      default: false
    },
    btnNewRecibo: {
      type: Boolean,
      default: false
    },
    btnTime: {
      type: Boolean,
      default: false
    },
    buttonbackCustom: {
      type: Boolean,
      default: false
    },
    btnNewAdd: {
      type: Boolean,
      default: false
    },
    btnAnexDown: {
      type: Boolean,
      default: false
    },
    btnApproveUser: {
      type: Boolean,
      default: false
    },
    titleHead: {
      type: String,
      default: ''
    },

    btnNewCorretor: {
      type: Boolean,
      default: false
    },
    btnSing: {
      type: Boolean,
      default: false
    },

    btnNewEmpreendimento: {
      type: Boolean,
      default: false
    },

    btnNew: {
      type: Boolean,
      default: false
    },
    selectHead: {
      type: Boolean,
      default: false
    },
    btnCanceSave: {
      type: Boolean,
      default: false
    },
    iconCancel: {
      type: String,
      default: null
    },
    iconSave: {
      type: String,
      default: null
    },
    btnApproveRequest: {
      type: Boolean,
      default: false
    },
    btnPendencyApproveRequest: {
      type: Boolean,
      default: false
    },
    buttontemplate: {
      type: Boolean,
      default: false
    },
    btnBack: {
      type: Boolean,
      default: false
    },
    btnImportPdf: {
      type: Boolean,
      default: false
    },
    btnNewEnterprise: {
      type: Boolean,
      default: false
    },
    btnSolicitacoes: {
      type: Boolean,
      default: false
    }
  },
  name: 'HeadDetailsGama',
  methods: {
    back () {
      document.location.reload()
    },
    openModal (modalRef) {
      this.$emit('openModal', modalRef)
    },
    closeModal (modalRef) {
      this.$emit('closeModal', modalRef)
    }
  }
}
</script>

<style scoped>
.btnEV{
 display: flex;
 gap: 3px;
 align-items: center;
}
.btn-new-gru{
 height: 40px;
 width: 181px;
 background: #008148;
 font-size: 14px;
 color: white;
 font-weight: bold;
 border: 1px solid #008148;
 margin: 0px;
 border-radius: 6px;
}
.btn-new-gru:hover{
 color: #008148;
 background: white;
}
.buttonImage {
 border: #008148 solid 1px;
 background-color:white;
 color: #008148;
 border-color:#008148;
 width: 40px;
 font-weight: bold;
 height: 40px;
 font-size: 25px;
 border-radius: 6px;
 display:flex;
 align-items: center;
}
.buttonImage:hover {
 color: white;
 background-color:#008148;
}
.buttonAddEmpreendimento{
 background-color: #008148;
 color: rgb(227, 220, 220);
 font: normal normal 600 17px/24px Segoe UI;
 border: none;
 width: 200px;
 height: 37px;
 border-radius: 6px;
}

.butonPdf{
 background-color: #008148;
 color: rgb(227, 220, 220);
 font: normal normal 600 13px/24px Segoe UI;
 border: none;
 width: 150px;
 height: 37px;
 border-radius: 6px;
}

.buttonTime{
 background-color: #ffa500;
 color: rgb(227, 220, 220);
 border: none;
 width: 40px;
 font-weight: bold;
 height: 37px;
 font-size: 15px;
 border-radius: 6px;
}
.buttonAddEmpreendimento:hover{
 background-color: #008147d7;
}

.buttonAddCorretor {
 background-color: #e0e5e3;
 color: #6f6e6e;
 border: none;
 width: 40px;
 font-weight: bold;
 height: 37px;
 font-size: 16px;
 border-radius: 6px;
}

.buttonAddCorretor:hover{
 background-color: rgba(141, 141, 141, 0.333);
}
.buttondown{
 width: 50px;
 height: 37px;
 background: none;
 border: 1px solid #008148;
 color: #008148;
 border-radius: 7px;
}
.buttondown:hover{
 background: #008148;
 color: white;
}

.head-right {
 height: 59px;
 display: flex;
 width: 100%;
 background: #ECEFF1 0% 0% no-repeat padding-box;
 border: 1px solid #CFD8DC;
 border-radius: 4px 4px 0px 0px;
 justify-content: space-between;
 opacity: 1;
}
.btnImages{
 background-color: white;
 color: white;
 border: none;
 width: 37px;
 height: 37px;
 font-size: 16px;
 border-radius: 6px;
}
.btn-cancel{
 background-color: white;
 color: white;
 border: none;
 width: 37px;
 height: 37px;
 font-size: 16px;
 border-radius: 6px;
}
.button-group{
 display: flex;
 margin-top: 10px;
}

.btn-head{
 background-color: #008148;
 color: white;
 border: none;
 height: 37px;
 width: 179px;
 font: normal normal 600 17px/24px Segoe UI;
 border-radius: 10px;
}
.btn-head:hover{
 background-color: #008147d7;
}
.btn-head-can{
 background-color: #a50000;
 color: rgb(255, 255, 255);
 border: none;
 width: 179px;
 height: 37px;
 font: normal normal 600 17px/24px Segoe UI;
 border-radius: 10px;
}
.btn-head-can:hover{
 background-color: #a50000b7;
}
.head-title-rg{
   color: #008148;
   font-size: 15px;
   font-weight: bold;
}

.btnTabela{
 font-weight: bold;
 background-color: #008148;
 color: white;
 border: none;
 width: 200px;
 height: 37px;
 font-size: 15px;
 border-radius: 6px;
}

.btnRequest{
 display: grid;
 align-items: center;
 padding-right: 10px;
}

.btnApproveRequest{
 border-radius: 4px;
 border: none;
 color: #fff;
 font: normal normal 600 16px/21px Segoe UI;
 padding-right: 10px;
 background: #008148;

}
.btnApproveRequestCancelar{
 border-radius: 4px;
 border: none;
 color: #fff;
 font: normal normal 600 16px/21px Segoe UI;
 padding-right: 10px;
 background: red;

}

.btnApproveRequest:hover{
 background: #01683a;
}
.btn-new-gru {
  height: 30px;
  width: 230px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}

.btn-new-gru:hover {
  color: white;
  background: #008148;
}

.btnImportExPdf {
  display: flex;
  align-items: center;
}

.btn-gru {
  height: 40px;
}

.aligtitle{
  display: flex;
  align-items: center;
}
.btnSolicitacao{
  display: flex;
  justify-content: flex-end;

}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/components/HeadDetails.vue